import { render, staticRenderFns } from "./CardSetPointItemList.vue?vue&type=template&id=2f7bbbf2&scoped=true&"
import script from "./CardSetPointItemList.vue?vue&type=script&lang=js&"
export * from "./CardSetPointItemList.vue?vue&type=script&lang=js&"
import style0 from "./CardSetPointItemList.vue?vue&type=style&index=0&id=2f7bbbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7bbbf2",
  null
  
)

export default component.exports